var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.122,
    height: 24.417,
    viewBox: "0 0 116.122 24.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9993",
    "data-name": "Group 9993",
    transform: "translate(-236.878 -370.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11662",
    "data-name": "Path 11662",
    d: "M235.3,181.238l-10.013-7.766a3.146,3.146,0,0,0-5.074,2.486,1.84,1.84,0,0,1-1.84,1.84H201.161a4.256,4.256,0,0,0-4.256,4.256v5.921a4.256,4.256,0,0,0,4.256,4.256h17.213a1.84,1.84,0,0,1,1.84,1.84,3.146,3.146,0,0,0,5.074,2.486l10.013-7.766A4.78,4.78,0,0,0,235.3,181.238Z",
    transform: "translate(39.973 197.885)",
    fill: "#bd9cde"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(292 371)",
    fill: "#df9758"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(313 371)",
    fill: "#df9758"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(334 371)",
    fill: "#df9758"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodSent);
export default __webpack_public_path__ + "static/media/food-sent.89cdef2bc6c6979e1cec4ddb6ae20384.svg";
export { ForwardRef as ReactComponent };